export * from 'notifications_historic/selectors/notifications_historic_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/selectors/index.js